export const DEMO_PREVIEW_STORAGE_KEY = 'erp4c_demo_preview_backup';

/** One-time localStorage key for passing preview tokens into a new window (same origin). */
export const demoPreviewBootStorageKey = (bootId) => `erp4c_preview_boot_${bootId}`;

/**
 * Demo preview runs in a separate tab/window but same origin as the admin UI. `localStorage` is shared
 * across tabs, so we must NOT put demo JWTs there — only this tab's `sessionStorage` holds the demo
 * session while `localStorage` keeps the administrator tokens untouched.
 */
const DEMO_PREVIEW_ACTIVE_TAB = 'erp4c_demo_preview_active_tab';
const DEMO_PREVIEW_ACCESS = 'erp4c_demo_preview_access_token';
const DEMO_PREVIEW_REFRESH = 'erp4c_demo_preview_refresh_token';

export function isDemoPreviewTab() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(DEMO_PREVIEW_ACTIVE_TAB) === '1';
  } catch {
    return false;
  }
}

/** Bearer token for API calls: marketing embed, demo session in this tab, else normal localStorage session. */
export function getAuthAccessToken() {
  if (typeof window === 'undefined') return null;
  try {
    if (sessionStorage.getItem('erp4c_marketing_preview_active_tab') === '1') {
      const t = sessionStorage.getItem('erp4c_marketing_preview_access_token');
      if (t) return t;
    }
    if (isDemoPreviewTab()) {
      return sessionStorage.getItem(DEMO_PREVIEW_ACCESS);
    }
    return localStorage.getItem('token');
  } catch {
    return null;
  }
}

export function getAuthRefreshToken() {
  if (typeof window === 'undefined') return null;
  try {
    if (sessionStorage.getItem('erp4c_marketing_preview_active_tab') === '1') {
      const t = sessionStorage.getItem('erp4c_marketing_preview_refresh_token');
      if (t) return t;
    }
    if (isDemoPreviewTab()) {
      return sessionStorage.getItem(DEMO_PREVIEW_REFRESH);
    }
    return localStorage.getItem('refreshToken');
  } catch {
    return null;
  }
}

export function activateDemoPreviewTabSession(accessToken, refreshToken) {
  sessionStorage.setItem(DEMO_PREVIEW_ACTIVE_TAB, '1');
  sessionStorage.setItem(DEMO_PREVIEW_ACCESS, accessToken);
  sessionStorage.setItem(DEMO_PREVIEW_REFRESH, refreshToken || '');
}

export function clearDemoPreviewTabSession() {
  sessionStorage.removeItem(DEMO_PREVIEW_ACTIVE_TAB);
  sessionStorage.removeItem(DEMO_PREVIEW_ACCESS);
  sessionStorage.removeItem(DEMO_PREVIEW_REFRESH);
}

/** After refresh-token; only writes when this tab is in demo preview mode. */
export function setDemoPreviewTabTokens(accessToken, refreshToken) {
  if (!isDemoPreviewTab()) return;
  sessionStorage.setItem(DEMO_PREVIEW_ACCESS, accessToken);
  sessionStorage.setItem(DEMO_PREVIEW_REFRESH, refreshToken || '');
}

/** Clear demo tab JWTs and admin backup (e.g. after refresh failure or forced logout). */
export function clearDemoPreviewAuthAndBackup() {
  clearDemoPreviewTabSession();
  try {
    sessionStorage.removeItem(DEMO_PREVIEW_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
